import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { AEMRoutes } from '../../../core/constants/routes.constant';

@Component({
  selector: 'par-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit, AfterViewInit {
  /***************Properties***************/
  mobileRoutes = {
    home: '/',
    legal: '/' + AEMRoutes.Mobile.Legal,
    majorLegal: '/' + AEMRoutes.Mobile.MajorLegal,
    majorPrivacy:  '/' + AEMRoutes.Mobile.MajorPrivacy,
    privacy: '/' + AEMRoutes.Mobile.Privacy
  };
  route: String = '';
  /***************Properties***************/

  /***************Constructor***************/
  constructor() {}

  ngOnInit() {
    this.route = AppUtilService.router.url;
  }

  ngAfterViewInit(): void {
    AppUtilService.scrollTo(0, 0);
  }
  /***************Constructor***************/
}
